import { useQuery, useQueryClient } from '@tanstack/react-query'
import { supabaseRpc } from '@/lib/supabaseClient'

export interface TrialState {
  trialUsed: boolean
  trialDropId: string | null
}

type TrialStateRow = {
  trial_used?: boolean
  trialUsed?: boolean
  trial_drop_id?: string | null
  trialDropId?: string | null
}

export function trialQueryKey(orgId: string | undefined) {
  return ['trial', orgId] as const
}

export function useTrialQuery(orgId: string | undefined) {
  return useQuery<TrialState>({
    queryKey: trialQueryKey(orgId),
    queryFn: async () => {
      if (!orgId) return { trialUsed: false, trialDropId: null }
      const raw = await supabaseRpc<TrialStateRow | TrialStateRow[]>('get_trial_state', { p_organization_id: orgId })
      const data = Array.isArray(raw) ? raw[0] : raw
      return {
        trialUsed: !!(data?.trial_used ?? data?.trialUsed),
        trialDropId: data?.trial_drop_id ?? data?.trialDropId ?? null,
      }
    },
    enabled: !!orgId,
  })
}

export function useInvalidateTrial() {
  const qc = useQueryClient()
  return (orgId: string | undefined) => {
    void qc.invalidateQueries({ queryKey: trialQueryKey(orgId) })
  }
}
